module.exports = __webpack_public_path__ + "static/media/background_320.9a201698.png";